import { useEffect, useState } from 'react';
import './App.css';
import { Routing } from "./appRoutes";
import { isiOSChrome } from './helpers/jsHelper';
import NoNetworkScreen from './common/NoNetworkScreen';
// import ConfiguratorViewer from './components/ConfiguratorViewer/ConfiguratorViewer'

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    if (isiOSChrome()) {
      const handleOrientationChange = () => {
        setTimeout(() => {
          const metaViewport = document?.querySelector('meta[name=viewport]');
          if (metaViewport) {
            metaViewport.setAttribute(
              'content',
              'width=device-width, initial-scale=1.0, maximum-scale=5.0'
            );
          }
          window.scrollTo(0, 0); // Optional: align top
        }, 500);
      };

      window.addEventListener('orientationchange', handleOrientationChange);

      return () => {
        window.removeEventListener('orientationchange', handleOrientationChange);
      };
    }
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      window.location.reload(); // auto-refresh on reconnect
    };
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOnline) {
    return <NoNetworkScreen />;
  }

  return (
      // <ConfiguratorViewer />
      <Routing />
  );
}

export default App;
